import styled from 'styled-components';


export const Div = styled.div`
    width:400px;
    height: 200px;
`